<template>
  <!-- 症状录入 -->
  <div class="symptom_entry">
    <patient-info-1 v-if="showInfo" :pageType="pageType" :info="info" />
    <div class="symptom_entry_body">
      <div class="ucard">
        <div class="ucard_hander">
          <div class="ucard_title_box">
            <span class="ucard_title">病历录入</span>
            <template v-if="info.isInternetHospital && !isConsultation">
              <span class="ucard_title_tip">[请到互联网医院小程序上接诊]</span>
              <span class="ucard_title_help" @click="showHelp = !showHelp">如何接诊
                <Icon type="md-help-circle" />
              </span>
            </template>
          </div>
          <div class="ucard_right">
            <Button type="primary" size="small" @click="sendDiseaseToPad" style="margin-right: 10px">发送到pad</Button>
            <Button :loading="indexSpin.show" @click="submitSymptom" type="primary" size="small">提交病历</Button>
          </div>
        </div>
        <div class="ucard_body">
          <div class="ulist">
            <div class="ulist_item selectList">
              <div class="label">症状<i class="request">*</i></div>
              <div class="value">
                <symptom-select-input ref="symptomSelectInputRef" placeholder="请选择症状" @submit="selectListChange"
                  @resertDialecticalSelect="resertDialecticalSelect" v-model="selectList" @input="saveData"
                  @etiologyListChange="etiologyListChange" :info="info" :etiologyIdObj="etiologyIdObj"
                  :etiologyList="etiologyList" :isFirstEtiology="isFirstEtiology" @showTip="showHelp = true"
                  @hideTip="isConsultation = true" />
              </div>
            </div>
            <div class="ulist_item diagnosis1">
              <div class="label">主诉<i class="request">*</i></div>
              <div class="value">
                <chief-complaint @input="saveData" v-model="diagnosisData" :symptomList="selectList"
                  placeholder="请点击选择主诉" />
              </div>
            </div>
            <div class="ulist_item diagnosis3" v-if="info.isInternetHospital">
              <div class="label">西医诊断<i class="request">*</i></div>
              <div class="value">
                <appletWesternInput @on-change="changeDiagnosis" filterable class="table_input diagnosis_select"
                  v-model="appletWesternCode" placeholder="请点击输入诊断拼音首字母" />
              </div>
            </div>
            <div class="ulist_item diagnosis2">
              <div class="label">诊断<i class="request">*</i></div>
              <div class="value">
                <Select @on-change="changeDiagnosis" class="table_input diagnosis_select" v-model="diagnosis2"
                  filterable placeholder="请点击输入诊断拼音首字母">
                  <Option v-for="item in diseaseInfos2" :value="item.value" :key="item.value">{{ item.labelAndPy }}
                  </Option>
                </Select>
                <westernMedicineDiseaseName :diagnosis="diagnosis2" />
                <span class="additional cureNumber" v-if="cureNumber">治愈:{{ cureNumber }}人</span>
                <courseTreatment :diseaseId="diagnosis2" :patientCode="info.patientCode" />
              </div>
            </div>
            <div class="ulist_item dialecticInfo" v-if="isHasAuth('YZ-33')">
              <div class="label">辨证<i class="request">*</i></div>
              <div class="value">
                <dialecticalSelect class="dialecticalSelect" v-model="dialecticInfo" ref="dialecticalSelectRef"
                  :info="info" :selectList="selectList" :etiologyList="etiologyList" :isOriginPeriod="isOriginPeriod" />
              </div>
            </div>
            <div v-if="info.sex == '女'" class="ulist_item">
              <div class="label">末次月经时间</div>
              <div class="value">
                <DatePicker class="table_input" placement="bottom-start" @on-change="saveData(false)"
                  v-model="menstruationLastTime" type="date" placeholder="末次月经时间">
                </DatePicker>
              </div>
            </div>
            <div class="ulist_item">
              <div class="label">患者自述</div>
              <div class="value">
                <Input class="table_input" @input="saveData" v-model="chiefComplaint"
                  placeholder="若症状库中没有符合的，请点击输入补充症状"></Input>
              </div>
            </div>

            <div class="ulist_item">
              <div class="label">既往史</div>
              <div class="value">
                <Input class="table_input" @input="saveData" v-model="history.pastHistory" placeholder="请输入"></Input>
              </div>
            </div>
            <div class="ulist_item">
              <div class="label">节育史</div>
              <div class="value">
                <Input class="table_input" @input="saveData" v-model="history.birthControlHistory"
                  placeholder="请输入"></Input>
              </div>
            </div>
            <div class="ulist_item" v-if="info.sex == '女'">
              <div class="label">生育史</div>
              <div class="value">
                <Input class="table_input" @input="saveData" v-model="history.birthHistory" placeholder="请输入"></Input>
              </div>
            </div>
            <div class="ulist_item">
              <div class="label">过敏史</div>
              <div class="value">
                <Input class="table_input" @input="saveData" v-model="history.allergyHistory" placeholder="请输入"></Input>
              </div>
            </div>
            <div class="ulist_item">
              <div class="label">家族史</div>
              <div class="value">
                <Input class="table_input" @input="saveData" v-model="history.familyHistory" placeholder="请输入"></Input>
              </div>
            </div>

            <div class="ulist_item">
              <div class="label">病程初复诊</div>
              <div class="value">
                <symptom-select-input @input="saveData" :filterDtId="initialDiagnosisDtId" placeholder="请选择病程初复诊"
                  @submit="initialDiagnosisChange" v-model="initialDiagnosis" :info="info"
                  :etiologyIdObj="etiologyIdObj" />
              </div>
            </div>
            <!-- 
						<div class="ulist_item">
							<div class="label">体格检查</div>
							<div class="value">
								<Input class="table_input" v-model="inspect1" placeholder="请点击输入"></Input>
							</div>
						</div>
						<div class="ulist_item">
							<div class="label">辅助检查</div>
							<div class="value">
								<Input class="table_input" v-model="inspect2" placeholder="请点击输入"></Input>
							</div>
						</div> 
						-->
          </div>
        </div>
      </div>

      <div v-if="showInGroup" class="ucard">
        <div class="ucard_hander">
          <div class="ucard_title">服务患者项</div>
          <div class="ucard_right"></div>
        </div>
        <div class="ucard_body">
          <div class="ulist">
            <div class="ulist_item">
              <div class="label">
                邀约打卡<i v-if="info.patientAge < 60" class="request">*</i>
              </div>
              <div class="value">
                <show-qr-code v-model="inGroup" :info="info" :diseaseType="Disease_Type()" :diagnosis2="diagnosis2"
                  :diagnosisData="diagnosisData" :symptomList="selectList" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ucard">
        <div class="ucard_hander">
          <div class="ucard_title">患者信息补充</div>
          <div class="ucard_right"></div>
        </div>
        <div class="ucard_body">
          <div class="ulist">
            <div class="ulist_item">
              <div class="label">喜好、生活状态</div>
              <div class="value">
                <hobby v-model="info" placeholder="点击设置喜好" />
              </div>
            </div>
            <div class="ulist_item">
              <div class="label">备注</div>
              <div class="value">
                <remarks-input placeholder="点击输入备注" v-model="info.otherInfo" :patientCode="info.patientCode" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="showHelp" width="700" title="互联网医院接诊提醒" footer-hide :closable="false" :mask-closable="false">
      <div class="symptom_select_input_tip">
        <div class="img-group img-group2">
          <div class="img-box img-box2">
            <img src="@/assets/images/web/s1.png" />
          </div>
        </div>
        <div class="footer">
          <Button size="large" type="primary" @click="showHelp = false">我已完成接诊</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { hasAuth } from "@/utils/uEdition.js";
import request from "@/utils/request.js";
import patientInfo1 from "./patientInfo/patientInfo1.vue";

import { mapGetters } from "vuex";
import SymptomSelectInput from "./symptomSelectInput.vue";
import ChiefComplaint from "./chiefComplaint.vue";
import ShowQrCode from "./showQRCode.vue";
export default {
  components: {
    patientInfo1,
    SymptomSelectInput,
    ChiefComplaint,
    ShowQrCode,
  },
  props: {
    //页面类型  true:前端医生 false:后端医生
    pageType: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      isConsultation: true, //是否是接诊
      diseaseNames: diseaseNames,
      showHelp: false,
      etiologyPathogenesis: [], //上一次的病因病机
      etiologyIdObj: {},
      cureNumber: 0,
      showInfo: false,
      photoReminder: false, //病历拍照提醒(待就诊)
      pastHistoryDtId: "20043", //既往史类型id
      initialDiagnosisDtId: "20029", //病程初复诊类型尖
      aidiagnostic: "",
      getDiagnosisSwitch: true,
      inspect1: "",
      inspect2: "",
      pastHistory: [],
      initialDiagnosis: [],
      diagnosisData: {
        diagnosis1: "",
        chiefComplaintTime: "",
        chiefComplaintTimeType: "",
        chiefComplaintDegree: "",
      },
      selectList: [],
      etiologyList: [],
      isFirstEtiology: true,
      diagnosis2: "",
      appletWesternCode: "", //	互联网小程序西医病名编码
      menstruationLastTime: "",
      dialecticInfo: [], //辩证
      chiefComplaint: "",
      inGroup: "", //是否加群
      history: {
        allergyHistory: "", //	过敏史
        birthControlHistory: "", //	节育史
        birthHistory: "", //	生育史
        familyHistory: "", //	家族史
        pastHistory: "", //	既往史
      },
    };
  },
  watch: {
    info() {
      this.init();
    },
    selectList(newValue, oldValue) {
      this.getDiagnosisSwitch = true;
    },
    userSystemConfig: {
      handler: function () {
        this.photoReminder = this.userSystemConfig.mrScanRemindVisit;
      },
      deep: true,
    },
    patientLastSymptom() {
      this.initSelectList();
    },
    diagnosis2() {
      this.getCureNumberByDiseaseId();
    },
    padIsConfirmName(newValue, oldValue) {
      let patientName = newValue.patientName;
      let message = "患者" + patientName + "已确认症状";
      if (newValue) {
        this.$Message.success(message);
      }
    },
    yzConfirmData(newValue, oldValue) {
      console.log(newValue);
      if (newValue) {
        this.$Message.success("发送成功，请等待患者确认");
      }
    },
  },
  computed: {
    ...mapGetters([
      "selectEtiology",
      "indexSpin",
      "saveCondition",
      "patientLastSymptom",
      "userInfo",
      "diseaseInfos2",
      "diseaseInfos",
      "dicts",
      "userSystemConfig",
      "keyInfo",
      "padIsConfirmName",
      "yzConfirmData",
      "ABSTRACT_ETIOLOGY",
      "patientCausePool",
      "is999",
    ]),
    // 是否原点期
    isOriginPeriod() {
      let list = this.dicts.MEDICAL_EXPERTISE || [];
      let obj = list.find((item) => item.label == this.userInfo.husDoctorId);
      return obj && obj.string4 == "0" ? true : false;
    },
    causePool() {
      return (
        this.patientCausePool[this.info.registerCode] || null // { body: {}, part: {}, symptomId:"" }
      );
    },
    /**
     * 2、以下情况符合任意一种时，邀约打卡录入项目不显示
     *（1）诊断病种的疗程在1个月以内
     *（2）医馆配置无需医生邀约打卡
     */
    showInGroup() {
      let start = true;
      let list = this.dicts["Disease_Type"] || [];
      let item = list.find((i) => i.value == this.diagnosis2);
      if (item) {
        start = item.string6Unit == "月" && item.string6 >= 1;
      }
      return this.userInfo.inviteType == 1 && start;
    },
  },
  methods: {
    etiologyListChange(list) {
      this.etiologyList = list;
      this.isFirstEtiology = false;
    },
    remoteMethod1(query) {
      // 字符转大写
      if (query !== "") {
        this.diseaseNames = diseaseNames.filter((i) => {
          return i.labelAndPy.indexOf(query.toLocaleUpperCase()) > -1;
        });
      } else {
        this.diseaseNames = [];
      }
    },
    changeDiagnosis() {
      this.saveData();
    },
    getCureNumberByDiseaseId() {
      if (this.diagnosis2) {
        let obj = {
          diagnosticid2: this.diagnosis2 * 1,
        };
        this.api2("getCureNumberByDiseaseId", obj).then((res) => {
          this.cureNumber = res.result.cureNumber;
          sessionStorage.setItem(
            "getCureNumberByDiseaseId_" + this.info.registerCode,
            this.cureNumber
          );
        });
      } else {
        this.cureNumber = 0;
      }
    },
    initSelectList() {
      if (this.patientLastSymptom.isRecall) {
        let obj = this.patientLastSymptom.symptomMain;
        let symptom = this.patientLastSymptom.recallSymptom;
        symptom.forEach((i) => {
          i.etiologyList = [];
        });

        let d = localStorage.getItem("selectList_" + this.info.registerCode);
        if (d) {
          this.selectList = JSON.parse(d);
        } else {
          this.selectList = symptom;
        }

        this.dialecticInfo = obj.dialecticInfo
          ? JSON.parse(obj.dialecticInfo)
          : [];

        this.pastHistory = symptom.filter(
          (i) => i.dtId == this.pastHistoryDtId
        );
        this.initialDiagnosis = symptom.filter(
          (i) => i.dtId == this.initialDiagnosisDtId
        );

        this.appletWesternCode = obj.appletWesternCode;
        this.diagnosisData = {
          diagnosis1: obj.diagnosticId1 + "",
          chiefComplaintTime: obj.chiefComplaintTime,
          chiefComplaintTimeType: obj.chiefComplaintTimeType,
          chiefComplaintDegree: obj.chiefComplaintDegree,
        };
        this.menstruationLastTime = obj.menstruationLastTime
          ? new Date(obj.menstruationLastTime)
          : "";
        this.chiefComplaint = obj.chiefComplaint;
        this.diagnosis2 = obj.diagnosticId2 + "";
      }
    },
    Disease_Type() {
      let list = this.dicts["Disease_Type"] || [];
      let obj = list.find((i) => i.value == this.diagnosis2);
      if (obj) {
        return obj.string5
          ? `疗程：${obj.string5 +
          obj.string5Unit +
          "~" +
          obj.string6 +
          obj.string6Unit
          }`
          : "";
      } else {
        return "";
      }
    },

    // 既往史变化
    pastHistoryChange() {
      this.selectList = this.selectList
        .filter((i) => i.parentId != this.pastHistoryDtId)
        .concat(this.pastHistory);
    },

    // 病程初复诊变化
    initialDiagnosisChange() {
      this.selectList = this.selectList
        .filter((i) => i.parentId != this.initialDiagnosisDtId)
        .concat(this.initialDiagnosis);
    },

    // 症状列表变化
    selectListChange() {
      this.initialDiagnosis = this.selectList.filter(
        (i) => i.parentId == this.initialDiagnosisDtId
      );
      this.updateHistory();
      this.getDiagnosisBySymptoms();
    },

    resertDialecticalSelect() {
      this.dialecticInfo = [];
      this.$refs.dialecticalSelectRef.resert();
      this.$refs.dialecticalSelectRef.groupList = [];
    },

    // 更新病史
    updateHistory() {
      // 若症状选择了已上环或已结扎则自动填入节育史框内（框内是空则自动填写）
      let birthControlHistory = [];
      let birthHistory = [];
      this.selectList.forEach((item) => {
        if (["已上环", "已结扎"].includes(item.label)) {
          birthControlHistory.push(item.label);
        }
        if (["产1胎或以上"].includes(item.label)) {
          birthHistory.push(item.label);
        }
      });
      if (!this.history.birthControlHistory) {
        this.history.birthControlHistory = birthControlHistory.join("、");
      }
      // 若症状选择了产1胎或以上则自动填入生育史框内（框内是空则自动填写）
      if (!this.history.birthHistory) {
        this.history.birthHistory = birthHistory.join("、");
      }
    },

    // 通过症状名称集返回中医诊断
    getDiagnosisBySymptoms() {
      if (this.getDiagnosisSwitch) {
        if (!this.selectList.length) return;
        this.getDiagnosisSwitch = false;
        let obj = {
          symptoms: this.selectList.map((i) => i.dsName).join("|"),
          patientAge: this.info.patientAge,
          patientSex: this.info.sex,
          dsIds: this.selectList.map((i) => i.dsId).join("|"),
        };

        return this.api2("getDiagnosisBySymptoms", obj).then((res) => {
          this.$store.commit("sendLog", {
            remarks: "通过症状名称集返回中医诊断",
            inParams: obj,
            outParams: res,
            apiName: "getDiagnosisBySymptoms",
          });

          let dName = res.result.classification_label;
          let item = this.diseaseInfos.find((i) => i.DiseaseName == dName);

          if (item && this.diagnosis2 != item.DiseaseId) {
            let content = `<p>AI系统诊断为：<span class="t_read">${dName}</span></p><p>您是否引用？</p>`;
            this.$store.commit("setN_tip", {
              onOk: () => {
                this.diagnosis2 = item.DiseaseId;
                this.aidiagnostic = this.common.clone(item);
                this.saveData();
              },
              okText: "引用",
              title: "",
              content,
            });
          }
        });
      }
    },
    setAcupoint() {
      this.$store.commit("acupoint", {
        // diagnosticName: this.diagnosis2.DiseaseName,
        diagnosticId: this.diagnosis2,
        symptomsIds: this.selectList.map((i) => i.dsId).join("|"),
      });
    },
    // 暂时缓存数据
    saveData() {
      this.setAcupoint();
      let obj = {
        appletWesternCode: "",
        aidiagnostic: "",
        getDiagnosisSwitch: true,
        inspect1: "",
        inspect2: "",
        pastHistory: [],
        initialDiagnosis: [],
        etiologyList: [],
        diagnosisData: {
          diagnosis1: "",
          chiefComplaintTime: "",
          chiefComplaintTimeType: "",
          chiefComplaintDegree: "",
        },
        history: {
          allergyHistory: "", //	过敏史
          birthControlHistory: "", //	节育史
          birthHistory: "", //	生育史
          familyHistory: "", //	家族史
          pastHistory: "", //	既往史
        },
        selectList: [],
        diagnosis2: "",
        menstruationLastTime: "",
        chiefComplaint: "",
        dialecticInfo: "",
      };
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          obj[key] = this[key];
        }
      }
      this.$store.commit("saveCondition", {
        key: this.info.registerCode,
        info: obj,
      });
    },

    isHasAuth(str) {
      return hasAuth(str);
    },

    // 合作医生保存患者症状
    async submitSymptom() {
      if (!this.selectList.length) {
        let node = $(this.$el).find(".selectList .symptom_select_input");
        node.addClass("jzmding");
        setTimeout(function () {
          node.removeClass("jzmding");
        }, 1000);

        this.$Message.warning("请先选择患者的病情【症状】后再提交！");
        return;
      }
      var symptom = [];
      var detailList = [];
      var dsIds = [];
      this.selectList.forEach((i) => {
        detailList.push({
          dtId: i.parentId, //二级症状编码
          dtName: i.parentName, //二级症状名称
          dsId: i.dsId, //症状编码
          dsName: i.dsName, //症状名称
          // 暂时关闭 下个版本发布
          symptomChanges: i.symptomChanges || 0, // 症状变化 0 无 1 加重 2 减轻
        });

        dsIds.push(i.dsId);

        let item = symptom.find((j) => j.dtId == i.parentId);
        if (item) {
          item.details.push({
            dsId: i.dsId,
            dsName: i.dsName,
          });
        } else {
          symptom.push({
            details: [
              {
                dsId: i.dsId,
                dsName: i.dsName,
              },
            ],
            dtId: i.parentId,
            dtName: i.parentName,
          });
        }
      });

      if (this.info.isInternetHospital && !this.appletWesternCode) {
        let node = $(this.$el).find(".diagnosis3 .table_input");
        node.addClass("jzmding");
        setTimeout(function () {
          node.removeClass("jzmding");
        }, 1000);
        this.$Message.warning("【西医诊断】是一定要选的哦！");
        return;
      }

      if (!this.diagnosisData.diagnosis1) {
        let node = $(this.$el).find(".diagnosis1 .chief_complaint");
        node.addClass("jzmding");
        setTimeout(function () {
          node.removeClass("jzmding");
        }, 1000);
        this.$Message.warning("【主诉】是一定要选的哦！");
        return;
      }

      if (!this.diagnosis2) {
        let node = $(this.$el).find(".diagnosis2 .table_input");
        node.addClass("jzmding");
        setTimeout(function () {
          node.removeClass("jzmding");
        }, 1000);
        this.$Message.warning("【诊断】是一定要选的哦！");
        return;
      }

      if (
        !this.dialecticInfo.length &&
        this.isHasAuth("YZ-33") &&
        this.$refs.dialecticalSelectRef.validate()
      ) {
        let node = $(this.$el).find(".dialecticInfo .dialecticalSelect");
        node.addClass("jzmding");
        setTimeout(function () {
          node.removeClass("jzmding");
        }, 1000);
        this.$Message.warning("【辨证】是一定要选的哦！");
        return;
      }

      // 患者年龄在60岁以上（含60岁）时，邀约打卡不作为必填项目，没有选择结果也可以提交病历
      if (this.showInGroup && !this.inGroup && this.info.patientAge < 60) {
        let node = $(this.$el).find(".ulist_item .showQRCode");
        node.addClass("jzmding");
        setTimeout(function () {
          node.removeClass("jzmding");
        }, 1000);
        this.$Message.warning("【邀约打卡】是一定要选的哦！");
        return;
      }

      // 是否病历拍照
      if (this.photoReminder) {
        let obj = {
          patientCode: this.info.patientCode,
          registerCode: this.info.registerCode,
          picType: 0,
        };

        this.photoReminder = false;
        let res = await this.api2("queryMedicalRecordScan", obj);
        if (!res.result.length) {
          this.$store.commit("setN_tip", {
            title: "提示",
            content: "病历还没有扫描哦",
          });
          return;
        }
      }

      let diagnosis1 = this.selectList.find(
        (i) => i.dsId == this.diagnosisData.diagnosis1
      );
      let diagnosis2 = this.diseaseInfos2.find(
        (i) => i.value == this.diagnosis2
      );

      var MainData = {
        dialecticInfo: JSON.stringify(this.dialecticInfo),
        dsIds, //	症状编码集,格式：555|666|999
        chiefComplaint: this.chiefComplaint, //患者自述
        chiefComplaintDegree: this.diagnosisData.chiefComplaintDegree, //主述程度
        chiefComplaintTime: this.diagnosisData.chiefComplaintTime, //	主诉时间
        chiefComplaintTimeType: this.diagnosisData.chiefComplaintTimeType, //主诉时间类型(0天 1周 2月 3年)
        menstruationLastTime: this.menstruationLastTime
          ? this.common.parseTime(this.menstruationLastTime, "{y}-{m}-{d}")
          : "", //末次月经
        patientCode: this.info.patientCode, //患者编码
        registerCode: this.info.registerCode, //挂号单号
        patientName: this.info.patientName, // 用户名
        cellphoneNo: this.info.cellphoneNo, // 手机号
        fsex: this.info.sex, // 性别
        patientAge: this.info.patientAge, //年龄
        isNoviceGuide: this.info.patientName == "演示患者" ? 1 : 0, //	是否新手指引， 0否 1是
        registerDate: this.info.registerDateTime, //挂号日期
        visitType: this.info.visitType, //就诊类型 1 初诊 2 复诊
        discountRate: this.info.discountRate, //药品折扣率SS
        hospitalCode: this.userInfo.hosptialCode, //医馆编码
        hospitalName: this.userInfo.hosptialName, //医馆名称
        hisdoctorid: this.userInfo.husDoctorId, //his医生ID
        diagnosticid1: diagnosis1 ? diagnosis1.dsId : "", //患者主诉ID
        diagnosticname1: diagnosis1 ? diagnosis1.dsName : "", //患者主诉名
        diagnosticid2: diagnosis2 ? diagnosis2.value : "", //患者主诉ID
        diagnosticname2: diagnosis2 ? diagnosis2.label : "", //患者主诉名
        aidiagnosticid: this.aidiagnostic ? this.aidiagnostic.DiseaseId : "", //	AI
        aiDiagnosticName: this.aidiagnostic
          ? this.aidiagnostic.DiseaseName
          : "", //	医生引用的Python诊断名，若没有引用则空值
        detailList,
        symptom, //症状串
      };

      if (this.info.isInternetHospital) {
        Object.assign(MainData, {
          appletWesternCode: this.appletWesternCode, //	互联网小程序西医病名编码
          appletWesternName: this.common.valueToLabel(
            //	互联网小程序西医病名名称
            diseaseNames,
            this.appletWesternCode
          ),
          appointNo: this.info.appointNo, //	互联网小程序就诊号
        });
      }

      // 加入加密狗信息
      Object.assign(MainData, this.keyInfo);
      this.postData(MainData);
    },

    postData(obj) {
      this.btnLoading = true;
      this.$store.commit("openSpin");

      this.api2("saveMedicalRecordSymptom", obj)
        .then(async (res) => {
          this.$store.commit("sendLog", {
            remarks: "合作医生保存患者症状",
            apiName: "saveMedicalRecordSymptom",
            inParams: obj,
            outParams: res,
          });
          this.$store.commit("hideIntro");

          this.$Message.success(res.result.msg);

          //未启用排队系统
          if (!config.queueUp) {
            this.$store.commit("closeSpin");

            // await this.saveMrEtiologyPathogenesisExplainList();

            //有病因选择权限的才调接口
            if (this.selectEtiology) {
              try {
                await this.saveMrEtiologyReason(res.result.symptomNo);
              } catch (error) {
                console.log("saveMrEtiologyReason保存病因失败");
              }
            }
            await this.autoPrescription(res.result.symptomNo);

            // 因socket消息发送会出现丢失的情况导致列表不有正常更新现改为主动请求
            // await this.$store.dispatch("getReloadOrderList");
            this.$router.push("/prescription/" + this.info.registerCode);
          }

          this.savePatientMainSymptom(obj);
          this.updatePatient();

          if (this.is999 && hasAuth("YZ-35")) {
            this.$store.dispatch("generateMrAnalysisReportPre", { ...obj, symptomNo: res.result.symptomNo, registerCode: this.info.registerCode });
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },

    /*
    generateMrAnalysisReportPre(obj, symptomNo) {
      request.post("/mra/generateMrAnalysisReportPre", {
        dataSource: 1,
        chiefComplaint: obj.diagnosticname1, //主诉
        diseaseName: obj.diagnosticname2,
        hospitalCode: obj.hosptialCode, // 医馆编码
        hospitalName: obj.hospitalName, // 医馆名称
        doctorCode: obj.hisdoctorid, // 医生编码
        doctorName: this.userInfo.doctorName, // 医生姓名
        symptomInputDTOList: obj.detailList, // 症状集合
        patientName: obj.patientName, // 病人姓名
        patientCode: obj.patientCode, // 病人编码
        phoneNo: obj.cellphoneNo, // 手机号
        patientSex: obj.fsex, // 性别
        patientAge: obj.patientAge, //年龄
        billNo: symptomNo, // 患者症状号
      }).then((res) => {
        let drugsList = (res.result.drugJson ? JSON.parse(res.result.drugJson) : []).map(item => {
          item.amount = item.quantity;
          return item;
        });

        this.$store.commit("addAiReturnPrescription", {
          key: this.info.registerCode,
          data: true,
        });

        let title = "智能体开方";
        this.$store.commit("addMedicalRecordSymptom_add", {
          id: this.info.registerCode,
          data: {
            drugsList,
            remark: title,
            title,
            planInfo: {
              planName: "",
              planExplain: "",
            },
          },
          isShift: 0,
        });
      });
    },
    */

    // 编辑患者 保存各种史
    updatePatient() {
      let obj = this.common.clone(this.history);
      obj.patientCode = this.info.patientCode;
      obj.requestChannel = 1; //调用渠道 1 云诊录病例
      if (obj.pastHistory.trim() == "无") obj.pastHistory = "";
      request.post("/saasreport/updatePatient", obj);
    },

    // 收集部位数据
    getEtiologyReasonList() {
      let arr = [];
      this.etiologyList.forEach((item) => {
        if (item.children.length) {
          arr.push({
            etiologyId: item.value,
            etiologyName: item.label,
            bottomReason: item.children.map((k) => {
              return { reason: k.label, isSelf: k.isSelf === 0 ? 0 : 1 };
            }),
          });
        }
      });
      return arr;
    },

    saveMrEtiologyReason(symptomNo) {
      return new Promise((resolve, reject) => {
        let etiologyReasonList = this.getEtiologyReasonList();
        if (etiologyReasonList.length) {
          localStorage.setItem(
            "etiologyReasonList_" + this.info.registerCode,
            JSON.stringify(etiologyReasonList)
          );
          this.api2("saveMrEtiologyReason", {
            hospitalCode: this.info.hospitalCode, // 医馆编码
            patientCode: this.info.patientCode, // 病人年龄
            billNo: symptomNo, // 患者症状号
            etiologyReasonList,
          })
            .then((res) => {
              resolve(res);
            })
            .catch(reject);
        } else {
          resolve("");
        }
      });
    },

    // 批量保存
    saveMrEtiologyPathogenesisExplainList(symptomNo) {
      return new Promise((resolve, reject) => {
        let dialecticsIds = [];
        let arr = [];
        this.selectList.forEach((j) => {
          j.etiologyList.forEach((item) => {
            if (item.value && item.children.length) {
              dialecticsIds.push(item.dialecticsId);
              arr.push({
                symptomNo: symptomNo, // 患者症状号
                patientCode: this.info.patientCode, // 患者编码
                bottomReason: item.children[0].label, // 病因底层原因
                bottomReasonJson: JSON.stringify(
                  item.children.filter((i) => i.label).map((i) => i.label)
                ), // 病因底层原因JSON
                id: item.mrepId || null, // 主键(修改时传入)
                dialecticsId: item.dialecticsId, // 辨证Id
                etiologyId: item.etiologyId, // 病因Id
                pathogenesisId: item.pathogenesisId, // 病机Id
                symptomId: item.symptomId, // 症状Id
                noRelationSymptomName: item.noRelationSymptomName,
                symptomName: item.symptomName,
                isTypical: item.isTypical,
              });
            }
          });
        });

        if (arr.length > 0) {
          this.api2("saveMrEtiologyPathogenesisExplainList", {
            explainDTOS: arr,
          })
            .then((res) => {
              let strDialecticsId = dialecticsIds.join(",");
              this.savePatientTreatmentProgress(strDialecticsId, symptomNo);
              resolve(res);
            })
            .catch(reject);
        } else {
          resolve("没有数据");
        }
      });
    },

    savePatientTreatmentProgress(strDialecticsId, symptomNo) {
      let obj = {
        patientCode: this.info.patientCode, // 病人年龄
        symptomNo: symptomNo, // 患者症状号
        dialecticsIds: strDialecticsId, // 辨证Id字符串,多个用逗号隔开 如11,35,67
        hospitalCode: this.info.hospitalCode, // 医馆编码
      };
      this.$store.commit("openSpin");
      this.api2("savePatientTreatmentProgress", obj)
        .then((res) => {
          this.$store.commit("closeSpin");
          this.$store.commit("setTreatmentProgressList", res.result);
        })
        .finally(() => { });
    },

    saveSelectList() {
      localStorage.setItem(
        "selectList_" + this.info.registerCode,
        JSON.stringify(this.selectList)
      );
    },

    saveSelectList2() {
      let list = this.selectList.filter(
        (i) =>
          i.etiologyList.length &&
          i.etiologyList.some((i) => i.value && i.children.some((k) => k.label))
      );
      if (list.length) {
        localStorage.setItem(
          "selectList_" + this.info.registerCode,
          JSON.stringify(list)
        );
      } else {
        // 可能存在招回的情况所以将缓存清一下
        localStorage.removeItem("selectList_" + this.info.registerCode);
      }
    },

    // 保存病历信息 用于就诊中页面
    savePatientMainSymptom(obj) {
      this.saveSelectList();

      let list = [];
      let oldData = sessionStorage.getItem(
        "listPatientMainSymptom_" + this.info.registerCode
      );
      if (oldData) {
        list = JSON.parse(oldData);
      }

      let dsVOList = [];
      let removeDsVOList = [];
      if (list.length && list[0].dsVOList) {
        let dsNames1 = obj.detailList.map((i) => i.dsId);
        let dsNames2 = list[0].dsVOList.map((i) => i.dsId);
        let diff = this.common.dsNameDiff(dsNames1, dsNames2);
        dsVOList = obj.detailList.map((i) => {
          i.isAddDs = diff[1].includes(i.dsId) ? 1 : 0;
          return i;
        });

        removeDsVOList = list[0].dsVOList.filter((i) =>
          diff[2].includes(i.dsId)
        );
      } else {
        dsVOList = obj.detailList;
      }

      let cureNumber = sessionStorage.getItem(
        "getCureNumberByDiseaseId_" + this.info.registerCode
      );

      let newObj = {
        addedTime: this.common.parseTime(new Date()),
        chiefComplaint: obj.chiefComplaint,
        chiefComplaintDegree: obj.chiefComplaintDegree,
        chiefComplaintTime: obj.chiefComplaintTime,
        chiefComplaintTimeType: obj.chiefComplaintTimeType,

        diagnosticDrugsVOList: null,

        diseaseTypeId: obj.diagnosticid2,
        diseaseTypeName: obj.diagnosticname2,
        doctorName: this.userInfo.doctorName,
        hisDrugsVOList: null,
        hospitalCode: this.info.hosptialCode,
        hospitalName: this.info.hosptialName,
        menstruationLastTime: obj.menstruationLastTime,
        // "patientAge": 38,
        // "patientCode": "1200001",
        // "patientName": "测试",
        // "patientSex": "男",
        // "prescriptionNo": "",
        // "symptomNo": "2307290001",
        purposeOfConsultationId: obj.diagnosticid1,
        purposeOfConsultationName: obj.diagnosticname1,
        sanfangDiagnosticDrugsVOList: null,
        treatmentProgressList: [],
        visitDate: this.info.registerDateTime,

        cureNumber,
        dsVOList,
        removeDsVOList,
      };
      list.unshift(newObj);
      sessionStorage.setItem(
        "listPatientMainSymptom_submit_" + this.info.registerCode,
        JSON.stringify(list)
      );
    },

    // 自动开方
    autoPrescription(symptomNo) {
      return new Promise((resolve, reject) => {
        this.$store.commit("openSpin");
        this.api2("autoPrescription", {
          isNoviceGuide: 0, //	是否新手指引， 0否 1是
          patientCode: this.info.patientCode, //患者编码
          symptomNo, //	症状编号
        })
          .then((res) => {
            resolve(res);
            this.$store.commit("closeSpin");
            // 测试
            // res.result = {"resultDirectReturn":0,"hundredYearsMapList":{},"resultCode":"1099","resultIsScattered":0,"sanFangMapList":{},"resultMessage":"执行异常!:在将 varchar 值 '50610&0' 转换成数据类型 int 时失败。,ERROR_SEVERITY:16,ERROR_STATE:1"};
            if (res.result.resultCode == "1099") {
              sessionStorage.setItem(
                "autoPrescriptionError_" + this.info.registerCode,
                res.result.resultMessage
              );
              this.$Message.error("自动开方出错：" + res.result.resultMessage);
            }

            this.$store.commit("saveHundredYearsMapList", {
              list: res.result.isScattered
                ? res.result.sanFangMapList
                : res.result.hundredYearsMapList, //1散方  0百年方
              id: this.info.registerCode,
            });
            this.$store.dispatch("getReloadOrderList");
          })
          .catch((err) => {
            this.$store.commit("closeSpin");
            reject(err);
          });
      });
    },
    // 发送症状到pad
    sendDiseaseToPad() {
      let cellphoneNo = "";
      if (this.info.cellphoneNo) {
        cellphoneNo = this.info.cellphoneNo.replace(
          /(\d{3})\d{4}(\d{4})/,
          "$1****$2"
        );
      }
      if (this.selectList.length === 0) {
        this.$Message.warning("请先选择患者症状");
        return;
      }
      // 发送症状到pad
      let objSend = {
        symptoms: JSON.stringify(this.selectList),
        patientAge: this.info.patientAge,
        patientSex: this.info.sex,
        patientName: this.info.patientName,
        patientCode: this.info.patientCode,
        cellphoneNo: cellphoneNo,
        hospitalCode: this.userInfo.hosptialCode, //医馆编码
        hospitalName: this.userInfo.hosptialName,
        dsIds: this.selectList.map((i) => i.dsId).join("|"),
        diseaseTypeName: this.chiefComplaint,
        messageType: 1, // 1 症状确认消息 2 五行辩证图 3 提交处方关闭五行辩证图
      };
      this.api2("sendingSymptoms", objSend).then((res) => {
        this.$Message.success(res.result);
      });
    },
    setEtiology() {
      this.etiologyIdObj = {};
      let d = localStorage.getItem("selectList_" + this.info.registerCode);
      if (d) {
        let list = JSON.parse(d);
        list.forEach((i) => {
          if (i.etiologyList.length) {
            this.etiologyIdObj[i.dsId] = i.etiologyList.map((j) => {
              return {
                etiologyId: j.mainKey,
                value: j.mainKey,
                etiologyName: j.string2,
                label: j.string2,
                symptomId: i.dsId,
                symptomName: i.dsName,
                bottomReason: j.children,
                children: j.children,
              };
            });
          }
        });
      }
      this.etiologyPathogenesis.forEach((i) => {
        let obj = this.etiologyIdObj[i.symptomId];
        if (obj) {
          let item = obj.find((j) => j.etiologyId == i.etiologyId);
          if (item) {
            let list = new Set([...item.bottomReason, ...i.bottomReason]);
            item.bottomReason = [...list];
            item.children = item.bottomReason;
          } else {
            obj.push(this.common.clone(i));
          }
        } else {
          this.etiologyIdObj[i.symptomId] = [i];
        }
      });
    },

    setEtiology2() {
      this.etiologyIdObj = {};
      let d = localStorage.getItem("selectList_" + this.info.registerCode);
      if (d) {
        let list = JSON.parse(d);
        list.forEach((i) => {
          i.etiologyList.forEach((j) => {
            if (j.value) {
              this.etiologyIdObj[j.etiologyId] = this.common.clone(j);
            }
          });
        });
      }

      this.etiologyPathogenesis.forEach((i) => {
        if (i.bottomReason == "[]") return;
        let list = JSON.parse(i.bottomReason);
        let obj = this.etiologyIdObj[i.etiologyId];
        if (obj) {
          list.forEach((j) => {
            if (!obj.children.find((x) => x.label == j.label)) {
              obj.children.push(j);
            }
          });
        } else {
          i.children = list;
          this.etiologyIdObj[i.etiologyId] = i;
        }
      });
    },
    async setConsultation() {
      if (this.info.isInternetHospital) {
        let r =
          await this.$refs.symptomSelectInputRef.getInternetAppletVisitDetailByAppointNo();
        if (r) {
          this.isConsultation = r.doctorReceptionStatus == 1;
        }
      } else {
        this.isConsultation = false;
      }
    },
    init() {
      this.isConsultation = true;
      this.getMrEtiologyReasonByPatientCode();

      this.dialecticInfo = [];
      this.etiologyList = [];
      this.isFirstEtiology = true;
      this.photoReminder = this.userSystemConfig.mrScanRemindVisit;
      this.aidiagnostic = "";
      this.getDiagnosisSwitch = true;
      this.inspect1 = "";
      this.inspect2 = "";
      this.pastHistory = [];
      this.initialDiagnosis = [];
      this.diagnosisData = {
        diagnosis1: "",
        chiefComplaintTime: "",
        chiefComplaintTimeType: "",
        chiefComplaintDegree: "",
      };
      this.history = {
        allergyHistory: "", //	过敏史
        birthControlHistory: "", //	节育史
        birthHistory: "", //	生育史
        familyHistory: "", //	家族史
        pastHistory: "", //	既往史
      };
      this.selectList = [];
      this.diagnosis2 = "";
      this.menstruationLastTime = "";
      this.chiefComplaint = this.info.chiefComplaint;
      this.inGroup = "";

      let item = this.saveCondition[this.info.registerCode]; //是否有缓存数据
      if (item) {
        //加载缓存数据
        item = item.info;
        for (const key in item) {
          if (Object.hasOwnProperty.call(item, key)) {
            this[key] = item[key];
          }
        }
      }
      this.$store.dispatch("getPatientLastSymptom", this.info.patientCode);
      this.setAcupoint();
      this.showInfo = true;
      this.getPatientBaseInfo();
      setTimeout(() => {
        this.setConsultation();
      }, 500);
      // this.getMedicalExpertiseData();
    },

    // 回填各史
    getPatientBaseInfo() {
      request
        .post("/hzda/getPatientBaseInfo", {
          patientCode: this.info.patientCode,
        })
        .then((res) => {
          let obj = res.result;
          for (const key in this.history) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
              this.history[key] = obj[key] || "";
            }
          }
        });
    },

    getMrEtiologyReasonByPatientCode() {
      let obj = {
        symptomNo: this.info.symptomNo, // 处方ID
        patientCode: this.info.patientCode, // 处方ID
      };
      this.$store.commit("openSpin");
      this.api2("getMrEtiologyReasonByPatientCode", obj).then((res) => {
        this.$store.commit("closeSpin");
        let list = [];
        res.result.forEach((i) => {
          let bottomReason = JSON.parse(i.bottomReason);
          if (bottomReason) {
            bottomReason.forEach((j) => {
              j.label = j.reason;
              j.active = true;
            });
          }
          let item = list.find((j) => j.etiologyId == i.etiologyId);
          if (item) {
            bottomReason.forEach((x) => {
              if (!item.children.find((y) => y.reason == x.reason)) {
                item.children.push(x);
              }
            });
          } else {
            list.push({
              value: i.etiologyId,
              label: i.etiologyName,
              etiologyId: i.etiologyId,
              etiologyName: i.etiologyName,
              children: bottomReason,
            });
          }
        });
        this.etiologyList = list;
        this.setEtiology();
      });
    },
    // getMedicalExpertiseData() {
    //   this.api2("getMedicalExpertiseData", {
    //     dataType: 2,
    //   }).then((res) => {
    //     this.isOriginPeriod = res.result
    //       .map((i) => i.doctorId)
    //       .includes(this.userInfo.husDoctorId);
    //   });
    // },
  },
  mounted() {
    this.$store.dispatch("getWideUseList", "MEDICAL_EXPERTISE");
    this.init();
  },
};
</script>

<style lang="scss">
.symptom_entry {
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  position: relative;

  .diagnosis_select,
  .western-medicine-disease-name {
    float: left;
    margin-right: 10px;
  }

  .symptom_entry_body {
    padding: 0 15px 15px;
    height: 100%;
    overflow-y: auto;
  }

  .table_input .ivu-input-wrapper {
    margin-bottom: 0;
  }

  .table_input .ivu-date-picker-focused input,
  .table_input .ivu-input:focus {
    box-shadow: none;
  }

  .table_input .ivu-select-selection,
  .table_input .ivu-select-input,
  .table_input .ivu-input {
    padding: 0;
    border: none;
    line-height: 26px;
    height: 26px;
  }

  .diagnosis_select {
    width: 200px;
    min-width: 50px;
  }
}

.ucard {
  margin-bottom: 15px;

  .ucard_hander {
    background: rgba(133, 58, 47, 0.15);
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px 5px 0 0;
    padding: 8px 15px;

    .ucard_title {
      color: #853a2f;
      font-weight: bold;
      font-size: 15px;
    }

    .ucard_title_tip {
      font-size: 13px;
      color: #b63208;
      font-weight: bold;
      margin: 0 10px;
      display: inline-block;
      animation: u_zoom 3s infinite 2s;
    }

    .ucard_title_help {
      font-size: 13px;
      cursor: pointer;
    }
  }

  .ucard_body {
    border: 1px solid #ddd;
  }
}

.ulist {
  .ulist_item {
    display: flex;
    min-height: 26px;
    line-height: 26px;
    border-bottom: 1px solid #ddd;

    &:last-child {
      border: none;
    }

    .label {
      padding: 5px 15px;
      width: 130px;
      border-right: 1px solid #ddd;

      .request {
        color: red;
        font-size: 14px;
        font-weight: bold;
        font-style: normal;
        padding-left: 5px;
      }
    }

    .value {
      padding: 5px 15px;
      flex: 1;

      .ivu-input-wrapper {
        margin-bottom: 0;
      }

      .additional {
        font-size: 12px;
        background: #fffce0;
        display: inline-block;
        line-height: 16px;
        padding: 4px 8px;
        float: right;
      }

      .cureNumber {
        background: #ffd1b1;
        border-radius: 3px;
      }

      .ivu-date-picker {
        width: 200px;
      }
    }
  }

  .course-treatment {
    float: right;
    margin-right: 10px;
  }
}
</style>